export const designTokens = {
  colors: {
    primary: '#3b82f6',
    primaryHover: '#2563eb',
    success: '#059669',
    successHover: '#047857',
    danger: '#dc2626',
    dangerHover: '#b91c1c',
    secondary: '#6b7280',
    secondaryHover: '#4b5563',
    
    background: '#f1f5f9',
    surface: '#ffffff',
    border: '#cbd5e1',
    borderLight: '#e2e8f0',
    
    text: {
      primary: '#0f172a',
      secondary: '#374151',
      tertiary: '#6b7280',
      muted: '#9ca3af'
    },
    
    status: {
      valid: '#059669',
      invalid: '#dc2626',
      pending: '#d97706',
      neutral: '#6b7280'
    }
  },
  
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '20px',
    xxl: '24px'
  },
  
  borderRadius: {
    sm: '4px',
    md: '6px',
    lg: '8px',
    xl: '12px'
  },
  
  shadows: {
    sm: '0 2px 4px -1px rgba(0, 0, 0, 0.1)',
    md: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
    lg: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)'
  }
};

// 공통 스타일 객체
export const commonStyles = {
  // 컨테이너
  pageContainer: {
    padding: designTokens.spacing.xxl,
    backgroundColor: designTokens.colors.background,
    minHeight: '100vh'
  },
  
  // 헤더
  pageHeader: {
    marginBottom: designTokens.spacing.xxl
  },
  pageTitle: {
    fontSize: '28px',
    fontWeight: '700',
    color: designTokens.colors.text.primary,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.md
  },
  
  // 카드
  card: {
    backgroundColor: designTokens.colors.surface,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadows.md,
    border: `1px solid ${designTokens.colors.border}`,
    padding: designTokens.spacing.xxl,
    marginBottom: designTokens.spacing.xxl
  },
  
  // 폼 요소
  formRow: {
    display: 'flex',
    gap: designTokens.spacing.xl,
    marginBottom: designTokens.spacing.lg,
    flexWrap: 'wrap'
  },
  formField: {
    flex: 1,
    minWidth: '200px'
  },
  formLabel: {
    display: 'block',
    fontSize: '14px',
    fontWeight: '600',
    color: designTokens.colors.text.secondary,
    marginBottom: designTokens.spacing.sm
  },
  input: {
    width: '100%',
    padding: `${designTokens.spacing.sm} ${designTokens.spacing.md}`,
    border: `1px solid ${designTokens.colors.border}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: '14px',
    color: designTokens.colors.text.primary
  },
  select: {
    width: '100%',
    padding: `${designTokens.spacing.sm} ${designTokens.spacing.md}`,
    border: `1px solid ${designTokens.colors.border}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: '14px',
    backgroundColor: designTokens.colors.surface,
    color: designTokens.colors.text.primary,
    cursor: 'pointer'
  },
  
  // 버튼
  buttonBase: {
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.sm,
    padding: `${designTokens.spacing.sm} ${designTokens.spacing.lg}`,
    border: 'none',
    borderRadius: designTokens.borderRadius.md,
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
  },
  
  // 테이블
  tableContainer: {
    backgroundColor: designTokens.colors.surface,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadows.md,
    border: `1px solid ${designTokens.colors.border}`,
    overflow: 'hidden',
    marginBottom: designTokens.spacing.xxl
  },
  tableWrapper: {
    overflowX: 'auto',
    overflowY: 'visible',
    paddingRight: '1px'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1000px'
  },
  th: {
    padding: `${designTokens.spacing.lg} ${designTokens.spacing.md}`,
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '600',
    color: designTokens.colors.text.primary,
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    backgroundColor: designTokens.colors.background,
    borderBottom: `2px solid ${designTokens.colors.border}`
  },
  td: {
    padding: designTokens.spacing.md,
    fontSize: '14px',
    color: designTokens.colors.text.primary,
    borderBottom: `1px solid ${designTokens.colors.borderLight}`,
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
  }
};

// 버튼 variants
export const buttonVariants = {
  primary: {
    ...commonStyles.buttonBase,
    backgroundColor: designTokens.colors.primary,
    color: designTokens.colors.surface
  },
  success: {
    ...commonStyles.buttonBase,
    backgroundColor: designTokens.colors.success,
    color: designTokens.colors.surface
  },
  danger: {
    ...commonStyles.buttonBase,
    backgroundColor: designTokens.colors.danger,
    color: designTokens.colors.surface
  },
  secondary: {
    ...commonStyles.buttonBase,
    backgroundColor: designTokens.colors.secondary,
    color: designTokens.colors.surface
  }
};

// 상태 스타일
export const statusStyles = {
  valid: {
    color: designTokens.colors.status.valid,
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.xs
  },
  invalid: {
    color: designTokens.colors.status.invalid,
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.xs
  },
  pending: {
    color: designTokens.colors.status.pending,
    fontWeight: '600',
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.xs
  }
};

// 목록 페이지 공통 스타일 (Agencies, Coupon, Faq 등 관리 목록 화면)
export const listPageStyles = {
  container: {
    padding: designTokens.spacing.xxl,
    backgroundColor: designTokens.colors.background,
    minHeight: '100vh'
  },
  header: {
    marginBottom: designTokens.spacing.xxl
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: designTokens.colors.text.primary,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.md
  },
  searchCard: {
    backgroundColor: designTokens.colors.surface,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadows.md,
    border: `1px solid ${designTokens.colors.border}`,
    padding: designTokens.spacing.xxl,
    marginBottom: designTokens.spacing.xxl
  },
  select: {
    padding: `${designTokens.spacing.sm} ${designTokens.spacing.md}`,
    border: `1px solid ${designTokens.colors.border}`,
    borderRadius: designTokens.borderRadius.md,
    fontSize: '14px',
    backgroundColor: designTokens.colors.surface,
    color: '#1e293b',
    cursor: 'pointer',
    minWidth: '120px'
  },
  searchButton: {
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.sm,
    padding: '10px 20px',
    backgroundColor: designTokens.colors.primary,
    color: designTokens.colors.surface,
    border: 'none',
    borderRadius: designTokens.borderRadius.md,
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
  },
  resetButton: {
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.sm,
    padding: '10px 20px',
    backgroundColor: designTokens.colors.secondary,
    color: designTokens.colors.surface,
    border: 'none',
    borderRadius: designTokens.borderRadius.md,
    fontSize: '14px',
    fontWeight: '500',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
  },
  deleteButton: {
    ...commonStyles.buttonBase,
    padding: `${designTokens.spacing.sm} ${designTokens.spacing.lg}`,
    backgroundColor: designTokens.colors.danger,
    color: designTokens.colors.surface
  },
  tableContainer: {
    backgroundColor: designTokens.colors.surface,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadows.md,
    border: `1px solid ${designTokens.colors.border}`,
    overflow: 'hidden',
    marginBottom: designTokens.spacing.xxl
  },
  tableWrapper: {
    overflowX: 'auto',
    overflowY: 'visible'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '1000px'
  },
  th: {
    padding: `${designTokens.spacing.lg} ${designTokens.spacing.md}`,
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '600',
    color: '#1e293b',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    backgroundColor: designTokens.colors.background,
    borderBottom: `2px solid ${designTokens.colors.border}`
  },
  td: {
    padding: designTokens.spacing.md,
    fontSize: '14px',
    color: '#1e293b',
    borderBottom: `1px solid ${designTokens.colors.borderLight}`,
    cursor: 'pointer',
    transition: 'background-color 0.2s ease'
  },
  checkbox: {
    width: '16px',
    height: '16px',
    cursor: 'pointer'
  },
  checkboxLabel: {
    cursor: 'pointer',
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
  userInfo: {
    lineHeight: '1.4'
  },
  noDataContainer: {
    ...commonStyles.card,
    textAlign: 'center',
    padding: `${designTokens.spacing.xxl} ${designTokens.spacing.lg}`,
    color: designTokens.colors.text.tertiary
  }
};

// 상세 페이지 공통 스타일 (AgenciesDetail, ReviewDetail 등 관리 상세 화면)
export const detailPageStyles = {
  header: {
    marginBottom: designTokens.spacing.xxl
  },
  title: {
    fontSize: '28px',
    fontWeight: '700',
    color: designTokens.colors.text.primary,
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.md,
    flexWrap: 'wrap'
  },
  idBadge: {
    fontSize: '16px',
    fontWeight: '500',
    color: designTokens.colors.secondary,
    backgroundColor: '#f3f4f6',
    padding: `${designTokens.spacing.xs} ${designTokens.spacing.md}`,
    borderRadius: designTokens.borderRadius.md,
    border: '1px solid #d1d5db'
  },
  section: {
    backgroundColor: designTokens.colors.surface,
    borderRadius: designTokens.borderRadius.xl,
    boxShadow: designTokens.shadows.md,
    border: `1px solid ${designTokens.colors.border}`,
    marginBottom: designTokens.spacing.xxl,
    overflow: 'hidden'
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    color: '#1e293b',
    margin: 0,
    display: 'flex',
    alignItems: 'center',
    gap: designTokens.spacing.sm
  },
  sectionContent: {
    padding: designTokens.spacing.xxl
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    minWidth: '600px'
  },
  th: {
    padding: `${designTokens.spacing.md} ${designTokens.spacing.lg}`,
    textAlign: 'left',
    fontSize: '12px',
    fontWeight: '600',
    color: '#1e293b',
    textTransform: 'uppercase',
    letterSpacing: '0.05em',
    backgroundColor: designTokens.colors.background,
    borderBottom: `2px solid ${designTokens.colors.border}`
  },
  td: {
    padding: `${designTokens.spacing.md} ${designTokens.spacing.lg}`,
    fontSize: '14px',
    color: '#1e293b',
    borderBottom: `1px solid ${designTokens.colors.borderLight}`
  },
  tdTitle: {
    backgroundColor: '#f8fafc',
    fontWeight: '600',
    color: designTokens.colors.text.secondary,
    minWidth: '120px'
  },
  checkbox: {
    width: '16px',
    height: '16px',
    cursor: 'pointer'
  }
};

// 배지 스타일
export const badgeStyles = {
  base: {
    padding: `${designTokens.spacing.xs} ${designTokens.spacing.sm}`,
    borderRadius: designTokens.borderRadius.sm,
    fontSize: '12px',
    fontWeight: '500',
    textAlign: 'center'
  },
  primary: {
    backgroundColor: '#dbeafe',
    color: '#1d4ed8'
  },
  success: {
    backgroundColor: '#dcfce7',
    color: '#16a34a'
  },
  warning: {
    backgroundColor: '#fef3c7',
    color: '#d97706'
  },
  neutral: {
    backgroundColor: designTokens.colors.background,
    color: designTokens.colors.text.primary
  }
};
